import { injectReducer } from '../../store/reducers'
import { getListPatient, getListAppointment, openPage, clearList } from './modules/doctors'

export default (store) => ({
  path : '',
  onEnter: function() {
      store.dispatch(clearList());
  },
  childRoutes: [
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Doctors = require('./containers/DoctorsContainer').default
      const reducer = require('./modules/doctors').default
      injectReducer(store, { key: 'doctors', reducer })
      // store.dispatch(getListPatient());
      // store.dispatch(getListAppointment());
      store.dispatch(openPage());
      cb(null, Doctors)
    }, 'doctors')
  }
})


// WEBPACK FOOTER //
// ./src/routes/DoctorDatabase/index.js